import { BASEURL } from "../../API/apiData";
import {bmcListsRoutes, bmcMainRoutes} from "./routes"

const getAllCustomerSegments = async (projectID , bmcID) => {
  const token = localStorage.getItem("token");

    const requestOptions = {
        method: "GET",
        headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        },
    };
    const response = await fetch(
        `${BASEURL}projects/${projectID}/business_model_canvas/${bmcID}/${bmcMainRoutes.segments}`,
        requestOptions
      );
      const results = await response.json();
      return results;
}

const createNewCustomerSegments = async (projectID, projectName, bmcID) => {
  const token = localStorage.getItem("token");

    const data = {
      segment_name: `${projectName} customer segments`
    }
    const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      };
    const response = await fetch(
    `${BASEURL}projects/${projectID}/business_model_canvas/${bmcID}/${bmcMainRoutes.segments}`,
    requestOptions
    );
    const results = await response.json();
    return results;
} 

// === LIST ITEMS ===
const createNewCustomerSegmentsList = async (projectID, bmcID, channelID, name ) => {
  const token = localStorage.getItem("token");

  const data = {
    customer_segment_item: {
      item_name: name
    }
  }

  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  };

  const response = await fetch(
    `${BASEURL}projects/${projectID}/business_model_canvas/${bmcID}/${bmcMainRoutes.segments}/${channelID}/${bmcListsRoutes.segmentsItems}`,
    requestOptions
    );

const results = await response.json();
return results;

}

const editNewCustomerSegmentsList = async (projectID, bmcID, channelID, name, ID ) => {
  const token = localStorage.getItem("token");

const data = {
  customer_segment_item: {
    item_name: name
  }
}

const requestOptions = {
  method: "PUT",
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  },
  body: JSON.stringify(data),
};

const response = await fetch(
  `${BASEURL}projects/${projectID}/business_model_canvas/${bmcID}/${bmcMainRoutes.segments}/${channelID}/${bmcListsRoutes.segmentsItems}/${ID}`,
  requestOptions
  );

const results = await response.json();
return results;

}

export {getAllCustomerSegments, createNewCustomerSegments, createNewCustomerSegmentsList, editNewCustomerSegmentsList }